module.exports = __webpack_public_path__ + "static/media/media-two.d0ab0217.png";